<template>
  <div class="shop-index" :style="style">
    <LazyContainer>
      <div class="content">
        <LazyItem
          notice-slot
          v-for="item in renderingComponents"
          :key="item.key"
        >
          <component :is="item.type" :config="item.config" />
        </LazyItem>
      </div>
    </LazyContainer>
    <BackTop
      :show="currentScrollTop > 300"
      v-if="pageConfig && pageConfig.config.show_back_top_btn"
    >
      <van-icon name="down" style="transform: rotate(180deg);" />
    </BackTop>
    <Tabbar />
  </div>
</template>

<script>
import Scroll from "../common/mixins/Scroll";
import * as Children from "../common";

export default {
  name: "shop", // 名字不能随意更改
  props: {},
  components: { ...Children },
  mixins: [Scroll],
  data() {
    return {
      componentList: [],
    };
  },
  created() {
    try {
      const value = document.getElementById("v_data").value;
      this.componentList = JSON.parse(value);
    } catch (e) {
      console.error("v_data", "为空");
    }
    this.restoreTop();
  },
  mounted() {},
  methods: {
    restoreTop() {
      const scrollY = sessionStorage.getItem("scrollY");
      if (!scrollY) {
        // this.$nextTick(() => {
        //   document.scrollingElement.style.scrollBehavior = "smooth";
        // });
        return;
      }
      console.log("restore scroll top", scrollY);
      setTimeout(() => {
        document.scrollingElement.scrollTop = +scrollY;
        // this.$nextTick(() => {
        //   document.scrollingElement.style.scrollBehavior = "smooth";
        // });
      }, 300);
    },
  },
  computed: {
    renderingComponents() {
      return this.componentList.filter(
        (it) => !["page_config"].includes(it.type)
      );
    },
    style() {
      if (!this.pageConfig) return;
      return {
        backgroundColor: this.pageConfig.config.bg_color,
      };
    },
    pageConfig() {
      return this.componentList.find((it) => it.type === "page_config") || null;
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
html {
  background-color: #f7f7f7;
  /*scroll-behavior: smooth;*/

  &::-webkit-scrollbar {
    display: none;
  }

  body {
    height: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  p,
  h1,
  h2,
  h3 {
    margin: 0;
  }
}

.shop-index {
  font-size: 15px;
  width: 100vw;
  padding-bottom: 60px;
  padding-bottom: calc(60px + constant(safe-area-inset-bottom));
  padding-bottom: calc(60px + env(safe-area-inset-bottom));
}
</style>
